import getSymbolFromCurrency from 'currency-symbol-map';

export const currencyToSymbol = (currency: string): string => {
  const symbol = getSymbolFromCurrency(currency);

  return symbol || '';
};
